<div class="main-content table-page table-page--compact plataforma-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Clientes</h1>
        <p>Cada cliente con sus empresas y los módulos contratados, que son lo único que puede repartir a su gente desde su portal.</p>
      </div>

      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                (click)="consultar()">
          <i class="material-icons">refresh</i>
          <span>Actualizar</span>
        </button>
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="nuevoCliente()">
          <i class="material-icons">domain_add</i>
          <span>Nuevo cliente</span>
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar">
        <mat-form-field appearance="outline" class="table-page__search-field">
          <mat-label>Buscar cliente, empresa o módulo</mat-label>
          <input matInput type="text" maxlength="60" [(ngModel)]="filtroBusqueda" aria-label="Buscar cliente, empresa o módulo" />
        </mat-form-field>
      </div>

      <div class="table-page__table-wrap" *ngIf="clientesFiltrados.length > 0; else clientesEmptyState">
        <table class="table-page__table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Empresas</th>
              <th>Módulos contratados</th>
              <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cliente of clientesFiltrados">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ cliente.nombre }}</strong>
                  <span class="table-page__subtext">Corporativo {{ cliente.idCorporativo }} · {{ cliente.usuariosActivos }} usuario(s) activo(s)</span>
                  <span class="table-page__subtext" *ngIf="cliente.correo">{{ cliente.correo }}</span>
                </div>
              </td>
              <td>
                <div class="table-page__cell-stack">
                  <span class="table-page__text" *ngFor="let empresa of cliente.empresas">
                    {{ empresa.razonSocial }}<span class="table-page__subtext" *ngIf="empresa.rfc"> · {{ empresa.rfc }}</span>
                  </span>
                  <span class="table-page__subtext" *ngIf="cliente.empresas.length === 0">Sin empresas</span>
                </div>
              </td>
              <td>
                <div class="plataforma-page__planes">
                  <button type="button" *ngFor="let plan of planesVigentes(cliente)" [class]="clasePlan(plan)"
                          (click)="ajustarPlan(cliente, plan)"
                          title="Cambiar cupo o vigencia">
                    <strong>{{ plan.sitio }}</strong>
                    <span>{{ plan.usuariosAsignados }} de {{ plan.cantidadUsuarios }} personas</span>
                    <span>Vence {{ soloFecha(plan.vigencia) }}</span>
                    <span class="plataforma-page__plan-aviso" *ngIf="cupoLleno(plan)">Cupo lleno</span>
                  </button>
                  <button type="button" *ngFor="let plan of planesVencidos(cliente)" [class]="clasePlan(plan)"
                          (click)="ajustarPlan(cliente, plan)"
                          title="Renovar">
                    <strong>{{ plan.sitio }}</strong>
                    <span>Vencido el {{ soloFecha(plan.vigencia) }}</span>
                  </button>
                  <span class="table-page__subtext" *ngIf="cliente.planes.length === 0">Sin módulos: nadie de este cliente ve nada al entrar</span>
                </div>
              </td>
              <td class="table-page__actions table-page__actions--multi">
                <button type="button" class="table-page__action-btn" title="Contratar módulo" aria-label="Contratar módulo" (click)="contratarModulo(cliente)">
                  <span class="material-icons">add_box</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #clientesEmptyState>
        <div class="table-page__empty" *ngIf="!loading; else clientesLoadingState">
          <span class="material-icons">domain</span>
          <h3>No hay clientes que mostrar</h3>
          <p>Con ese filtro no sale ninguno. Use «Nuevo cliente» para dar de alta uno.</p>
        </div>
      </ng-template>

      <ng-template #clientesLoadingState>
        <div class="table-page__empty table-page__empty--loading">
          <span class="material-icons">hourglass_top</span>
          <h3>Consultando clientes</h3>
          <p>Espere un momento.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
